import {
  createComponent,
  createElement,
  createHook
} from "./CFEUKV6C.js";

// src/role/role.ts
var elements = [
  "a",
  "button",
  "details",
  "dialog",
  "div",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "section",
  "select",
  "span",
  "textarea",
  "ul",
  "svg"
];
var useRole = createHook((props) => {
  return props;
});
var Role = createComponent((props) => {
  return createElement("div", props);
});
if (process.env.NODE_ENV !== "production") {
  Role.displayName = "Role";
}
Object.assign(
  Role,
  elements.reduce((acc, element) => {
    acc[element] = createComponent((props) => {
      return createElement(element, props);
    });
    return acc;
  }, {})
);

export {
  useRole,
  Role
};
